import React from 'react'
import styled from 'styled-components'
import { Modal, ModalContentPadding } from './Modal'
import { ModalType } from '../../states/modals/ModalType.constants'
import { useAppSelector } from '../../hooks/useAppSelector'
import { HeaderText3 } from '../HeaderText'
import { Text } from '../Text'
import { PaymentSuccessIcon } from '../Icon/PaymentSuccessIcon'
import { STYLES } from '../../static/style'

interface IPaymentSuccessModalProps {}

const StyledPaymentSuccessIcon = styled(PaymentSuccessIcon)`
  color: ${STYLES.PRIMARY_COLOR};
  font-size: 5rem;
`

const PaymentSuccessModal: React.FC<IPaymentSuccessModalProps> = () => {
  const { modalType, data } = useAppSelector(({ modals }) => modals)

  if (modalType !== ModalType.PAYMENT_SUCCESS) {
    return null
  }
  return (
    <Modal isCenter contentPadding={ModalContentPadding.LG}>
      <StyledPaymentSuccessIcon />
      <HeaderText3>Payment successful</HeaderText3>
      <Text>Thank you! Your payment is complete.</Text>
      {(data as any)?.children}
    </Modal>
  )
}

export default PaymentSuccessModal
